import React from 'react';
import { Link, Navigate } from 'react-router-dom'
import { Table, Card, Row, Col, Form, DatePicker, Select, InputNumber, Button, Space, message } from 'antd';
import { LoadingOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import FormModal from '../components/modalForm'
import FormClientModal from '../../customers/components/FormModal';
import axios from '../../services/axios'
import SelectSearchInput from '../../utils/components/selectSearchInput';
import DatePickerCustom from '../../utils/components/datePicker';
import { exportToExcel } from '../../utils/exportExcel';
import moment from 'moment';
import { getNomItineraire } from '../../utils/constants/pays';

const { RangePicker } = DatePicker;
const { Option } = Select;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

interface IProps {
  pagination: {
    pageSize: Number,
    current: Number
  }
}

const Retrait = () => {
  const [visible, setVisible] = React.useState(false);
  const [visibleClient, setVisibleClient] = React.useState(false);
  const [confirmLoading, setConfirmLoading] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [pagination, setPagination] = React.useState({
    current: 1,
    pageSize: 100
  });
  const [loading, setLoading] = React.useState(false);
  const [devises, setDevises] = React.useState([])
  const [clients, setClients] = React.useState([])
  const [sumRetraitByDevise, setSumRetraitByDevise] = React.useState({})
  const [redirect, setRedirect] = React.useState(false)
  const [dateStart, setDateStart] = React.useState(moment(new Date()).format('YYYY-MM-DD'));
  const [dateEnd, setDateEnd] = React.useState(moment(new Date()).format('YYYY-MM-DD'));
  const [idDevise, setIdDevise] = React.useState(null)

  const [form] = Form.useForm();

  React.useEffect(() => {
    const dateJour = new Date();
    const dateFormated = moment(dateJour).format('YYYY-MM-DD');
    fetchData({ pagination } as IProps);
    getDevise()
    getClient()
    getSumRetraitByDevise(dateFormated, dateFormated)
  }, [])

  const getRandomuserParams = (params: any) => ({
    results: params.pagination.pageSize,
    page: params.pagination.current,
    ...params,
  });
  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    fetchData({
      sortField: sorter.field,
      sortOrder: sorter.order,
      pagination,
      ...filters,
    });
  };

  const getClientVisible = () => {
    setVisibleClient(true)
  }

  const getClient = () => {
    axios.get('/clients')
      .then(response => {
        
        setClients(response.data);
        setLoading(false)
      });
  }

  const fetchData = (params: any) => {
    setLoading(true);
    const dateJour = new Date();
    const dateFormated = moment(dateJour).format('YYYY-MM-DD');

    axios.get(`/operations/type/retrait/${dateFormated}/${dateFormated}`)
      .then(response => {
        
        setData(response.data)
        setLoading(false)
      });
  };

  const getDevise = () => {
    axios.get('/devises')
      .then(response => {
        
        setDevises(response.data);
        setLoading(false)
      });
  }
  const getSumRetraitByDevise = (start: any, end: any) => {
    axios.get(`/operations/rapport/sum-retrait/by-devise/${start}/${end}`)
      .then(response => {
        
        setSumRetraitByDevise(response.data);
        setLoading(false)
      });
  }

  const onCreate = (values: any) => {
    const dateJour = new Date();
    const dateFormated = moment(dateJour).format('YYYY-MM-DD');
    return axios.post('/operations/new', values)
      .then(function (response) {
        setLoading(false);
        setRedirect(true)
        fetchData(pagination)
        getSumRetraitByDevise(dateFormated, dateFormated)
        form.resetFields();
        setVisible(false);
      })
      .catch(function (error) {
        setLoading(false);
        message.error(error.response?.data || "Erreur d'insertion");
        throw error;
      });
  };

  const onClientCreate = (values: any) => {
    axios.post('/clients/new', values)
      .then(function (response) {
        getClient()
        
        setLoading(false);
        form.resetFields();
        setVisibleClient(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  const onChange = (name: string, value: any) => {
    form.setFieldsValue({ [name]: value })
    setLoading(true)
    setIdDevise(value)
    axios.get(`/operations/type/retrait/${dateStart}/${dateEnd}/${value}`)
      .then(response => {
        
        setData(response.data)
        setLoading(false)
      });
  }
  function onSearch(val: string) {
    
  }
  const handleOk = (id: number) => {
    
    setLoading(true)
    axios.delete(`/operations/delete/${id}`)
      .then(response => {
        
        axios.get(`/operations/type/retrait/${dateStart}/${dateEnd}`)
          .then(response => {
            
            setData(response.data)
            getSumRetraitByDevise(dateStart, dateEnd)
            setLoading(false)
          });
        setLoading(false)
      });

  };


  const handleCancel = () => {
    console.log('Clicked cancel button');
  };

  // Libellé identique au tableur: "Transfert <départ> <récupération>".
  const libelleSortie = (row: any) =>
    `Transfert ${getNomItineraire(row.pays_depart || 'LABE')} ${getNomItineraire(row.pays_recuperation)}`;

  const handleExport = () => {
    const rows = data.map((row: any, index: number) => ({
      'N°': index + 1,
      'Date': row.date_operation,
      'Libellé sortie': libelleSortie(row),
      'Client': `${row.client?.prenom ?? ''} ${row.client?.nom ?? ''}`.trim(),
      'Déposant': row.nom_deposant || 'Par le client lui même',
      'Téléphone': row.tel_deposant || '-',
      'Bénéficiaire': row.beneficiaire || '-',
      'Montant': Number(row.montant_sortie) || 0,
      'Devise': row.devisesortie?.code,
      'Créé par': row.user ? `${row.user.prenom} ${row.user.nom}` : '-',
    }));
    exportToExcel(`sorties_${dateStart}_${dateEnd}`, 'Sorties', rows);
  };

  const columns = [
    {
      title: "N°",
      key: "index",
      render: (row: any, value: any, index: number = 0) => <>{index + 1}</>,
    },
    {
      title: 'Date',
      dataIndex: 'date_operation',
      key: 'date_operation'
    },
    {
      title: 'Libellé sortie',
      key: 'libelle_sortie',
      render: (row: any) => libelleSortie(row),
    },
    {
      title: 'Client',
      key: 'client',
      width: 180,
      render: (row: any) => (
        <span style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
          {row.client?.prenom} {row.client?.nom}
        </span>
      ),
    },
    {
      title: 'Déposant',
      key: 'nom_deposant',
      render: (row: any) => <>{row.nom_deposant || 'Par le client lui même'}</>,
    },
    {
      title: 'Téléphone',
      dataIndex: 'tel_deposant',
      key: 'tel_deposant',
      render: (tel_deposant: string) => <>{tel_deposant || '-'}</>,
    },
    {
      title: 'Bénéficiaire',
      dataIndex: 'beneficiaire',
      key: 'beneficiaire',
      render: (beneficiaire: string) => <>{beneficiaire || '-'}</>,
    },
    {
      title: 'Montant',
      dataIndex: 'montant_sortie',
      align: 'right',
      key: 'montant_sortie',
      render: (montant: any, row: any) => (
        <b>
          {parseFloat(montant).toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' ' + row.devisesortie?.code}
        </b>
      ),
    },
    {
      title: 'Créé par',
      key: 'user',
      render: (row: any) => <>{row.user ? `${row.user.prenom} ${row.user.nom}` : '-'}</>,
    },
    {
      title: 'Action',
      dataIndex: 'id',
      key: 'id',
      render: (id: any) => (
        <Button title="Editer">
          <Link style={{ marginRight: 10 }} to={`/depot/edit/${id}`}><EditOutlined /></Link>
        </Button>
      )
    },
  ];
  const onDateChange = (dates: any, dateStrings: any) => {
    setLoading(true)
    
    setDateStart(dateStrings[0])
    setDateEnd(dateStrings[1])
    if (idDevise) {
      axios.get(`/operations/type/retrait/${dateStrings[0]}/${dateStrings[1]}/${idDevise}`)
        .then(response => {
          
          setData(response.data)
          setLoading(false)
        });
    }
    else {
      axios.get(`/operations/type/retrait/${dateStrings[0]}/${dateStrings[1]}`)
        .then(response => {
          
          setData(response.data)
          setLoading(false)
        });
    }

    getSumRetraitByDevise(dateStrings[0], dateStrings[1])
  }
  return <>
    <Card size="small" title={<h4>Liste des Retraits</h4>} extra={<Space>
      <Button onClick={handleExport}>Exporter Excel</Button>
      <Button
        type="primary"
        onClick={() => {
          setVisible(true);
        }}
      >
        Nouveau
      </Button>
    </Space>} >
      <Row justify='end'>
        <Form layout='inline'>
          <Form.Item label="Dates">
            <DatePickerCustom
              onChange={onDateChange}
            />
          </Form.Item>
          <Form.Item label='Devise'>
            <SelectSearchInput
              onChange={(v) => onChange('devise', v)}
              onSearch={(value) => onSearch(value)}
              data={devises}
              label='code'
              valueLabel='id'
              placeholder="Selectionnez la devise "
            />
          </Form.Item>
        </Form>
      </Row>
      <br />
      <br />

      <Table
        columns={columns as any}
        rowKey={(record: any) => record.login}
        dataSource={data}
        pagination={{ pageSize: 100 }}
        loading={loading}
        scroll={{ x: 'max-content' }}
      />
      <Row justify='end'>
        {
          Object.entries(sumRetraitByDevise).map(
            (val, index) => <Col xs={12} sm={8} md={6} lg={4} key={index}>
              <Form.Item label={`Total en ${val[0]}`} >
                <InputNumber
                  disabled
                  value={val[1] as number}
                  style={{ width: '100%', fontSize: 13 }}
                  formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value: any) => value.replace(/\$\s?|(,*)/g, '')}
                />
              </Form.Item>
            </Col>
          )
        }

      </Row>
      <FormModal
        visible={visible}
        setClientVisible={getClientVisible}
        onCreate={onCreate}
        clients={clients}
        onCancel={() => {
          setVisible(false);
        }}
      />
      <FormClientModal
        visible={visibleClient}
        onCreate={onClientCreate}
        onCancel={() => {
          setVisibleClient(false);
        }}
      />
    </Card>
    {
      redirect ? (<Navigate to="/retrait/" replace />) : ''
    }
  </>;
}

export default Retrait;